import {useLocation} from "react-router-dom";
import DiscoverLanding from "./discover-landing";
import AchievementsView from "./achievements";
import AchievementGroupDetailView from "./achievements/group-detail";
import LifeJourney from "./life-journey";
import type {DiscoverProps} from "./types";
import {usePageTitle} from "../../helpers/usePageTitle";
import './discover.scss';

export default function Discover(props: DiscoverProps) {
    const location = useLocation();
    const isLifeJourney = location.pathname === '/discover/life-journey';
    const isAchievements = location.pathname === '/discover/achievements';
    const isAchievementDetail = location.pathname.startsWith('/discover/achievements/');

    usePageTitle(
        isLifeJourney ? 'Life Journey' : isAchievements || isAchievementDetail ? 'Achievements' : 'Discover',
        isLifeJourney || isAchievements || isAchievementDetail ? 'Discover' : undefined
    );

    if (isLifeJourney) {
        return <LifeJourney {...props} />;
    }

    if (isAchievements) {
        return <AchievementsView {...props} />;
    }

    if (isAchievementDetail) {
        return <AchievementGroupDetailView {...props} />;
    }

    return <DiscoverLanding {...props} />;
}
